import { useSession } from './useSession'
import { resolvePlan, planLabel, hasPaidPlan, type PlanId, type StoredPlan } from '../lib/plans'

export type { PlanId, StoredPlan }

/**
 * Subscription state for the current user.
 *
 * Access is gated on `status`, never on the plan — see SubscriptionGuard. The
 * previous `isPro` / `isStarter` flags encoded the retired tiering and had no
 * consumers, so they are gone rather than renamed.
 */
export function useSubscription() {
  const { user } = useSession()
  const stored = (user as any)?.plan as string | null | undefined
  const status: string = (user as any)?.subscription_status || 'active'
  return {
    /** Current tier, or null when the account has no paid plan. */
    plan: resolvePlan(stored),
    /** Raw stored value, including legacy names — for debugging and support. */
    storedPlan: stored ?? null,
    label: planLabel(stored),
    isPaid: hasPaidPlan(stored),
    status,
    isActive: status === 'active' || status === 'trial',
  }
}
